import React from 'react';
import { useNavigate } from 'react-router-dom';

const Logo = ({ size = 'md', showText = true, className = '' }) => {
  const navigate = useNavigate();
  
  const sizes = {
    sm: 'w-10 h-10',
    md: 'w-16 h-16',
    lg: 'w-20 h-20',
    xl: 'w-24 h-24'
  };
  
  const textSizes = {
    sm: 'text-xl',
    md: 'text-3xl',
    lg: 'text-4xl',
    xl: 'text-5xl'
  };
  
  return (
    <div 
      className={`inline-flex items-center gap-3 cursor-pointer ${className}`}
      onClick={() => navigate('/')}
    >
      <img 
        src="/AutomateSEO-logo.png" 
        alt="AutomateSEO.ai Logo" 
        className={`${sizes[size]} object-contain`}
      />
      {showText && (
        <span className={`${textSizes[size]} font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent`}>
          AutomateSEO.ai
        </span>
      )}
    </div>
  );
};

export default Logo;
